'use client';

import { c as _c } from "react/compiler-runtime";
import { LaptopIcon, MoonIcon, SunIcon } from 'lucide-react';
import { useTheme } from 'next-themes';
import { ToggleGroup, ToggleGroupItem } from '../_base/ToggleGroup';
export function ThemeToggleGroup() {
  const $ = _c(8);
  const {
    setTheme,
    theme
  } = useTheme();
  let t0;
  if ($[0] !== setTheme) {
    t0 = value => {
      if (value) {
        setTheme(value);
      }
    };
    $[0] = setTheme;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ToggleGroupItem value="light" aria-label="Light mode"><SunIcon className="h-4 w-4" /></ToggleGroupItem>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ToggleGroupItem value="dark" aria-label="Dark mode"><MoonIcon className="h-4 w-4" /></ToggleGroupItem>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ToggleGroupItem value="system" aria-label="System mode"><LaptopIcon className="h-4 w-4" /></ToggleGroupItem>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t0 || $[6] !== theme) {
    t4 = <ToggleGroup type="single" variant="outline" value={theme} onValueChange={t0}>{t1}{t2}{t3}</ToggleGroup>;
    $[5] = t0;
    $[6] = theme;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}